import React, { Component } from "react";
import "rc-slider/assets/index.css";
import "./index.css";
import RangeSlider from "rc-slider";

const createSliderWithTooltip = RangeSlider.createSliderWithTooltip;
const Range = createSliderWithTooltip(RangeSlider.Range);
const Handle = RangeSlider.Handle;

export default class Slider extends Component {
  state = { isSliderFocused: false };
  componentDidMount() {
    document.addEventListener("click", this.handleClick, false);
  }
  componentWillUnmount() {
    document.removeEventListener("click", this.handleClick, false);
  }
  handleClick = event => {
    if (this.slider) {
      if (this.slider.contains(event.target)) {
        this.setState({ isSliderFocused: true });
      } else {
        this.setState({ isSliderFocused: false });
      }
    }
  };
  render() {
    const { isSliderFocused } = this.state;
    const {
      min,
      max,
      defaultValue,
      readOnly,
      onChange,
      label,
      value
    } = this.props;
    let _classes = ["form-group", "form-group-custom", "form-control-clear"];
    if (isSliderFocused) {
      _classes.push("active");
    }
    if (!label) {
      _classes.push("form-control-clear-no-head");
    }
    return (
      <div
        className={_classes.join(" ")}
        ref={element => (this.slider = element)}
      >
        {label ? <label>{label}</label> : null}
        <div className="form-control-clear-wrap">
          <Range
            min={min}
            max={max}
            defaultValue={defaultValue}
            value={value}
            tipFormatter={value => `${value}`}
            disabled={readOnly}
            onChange={value => {
              onChange(value[0], value[1]);
            }}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/_components/UI/Slider/index.js